module.exports = __webpack_public_path__ + "static/offer-slide-ea2f14b8a29bb1701fe134e858784664.png";